import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link, useResolvedPath } from 'react-router-dom';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useDeleteReportTaskMutation } from '../../../../../../../entities/reports/reportsResource/redux/reportsResource.api';

function Actions({ reportTaskId, refreshData }) {
  const base = useResolvedPath('.');

  const [anchorEl, setAnchorEl] = useState(null);

  const [deleteReportTask] = useDeleteReportTaskMutation();

  const open = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleDelete = async () => {
    await deleteReportTask(reportTaskId);
    refreshData();
    handleMenuClose();
  };

  return (
    <div>
      <IconButton onClick={handleMenuOpen} size="small">
        <MoreVertIcon fontSize="small" />
      </IconButton>

      <Menu id="solution-menu" anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
        <MenuItem component={Link} to={`${`${base.pathname}/edit/${reportTaskId}`}`}>
          Редактировать
        </MenuItem>
        <MenuItem onClick={handleDelete} sx={{ color: 'red' }}>
          Удалить
        </MenuItem>
      </Menu>
    </div>
  );
}

Actions.propTypes = {
  refreshData: PropTypes.func.isRequired,
  reportTaskId: PropTypes.number.isRequired,
};

export default Actions;
